// Klaviyo ADD-TO-CART Event
$(function () {
  console.log('[Klaviyo] DOM Loaded');
  var _learnq = window._learnq || [];
  var klAjax = true;

  function addedToCart(item) {
    console.log('[Klaviyo] Add to Cart Running');
    fetch(`${window.location.origin}/cart.js`)
      .then(res => res.json())
      .then(data => {
        var cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items
        };
        if (item && typeof item === 'object') {
          cart = Object.assign(cart, item);
        }
        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', cart]);
          klAjax = false;
        }
      });
  }

  var mainFormATCs = $('button.product__submit');
  console.log('[Klaviyo] Form Buttons: ', mainFormATCs);

  mainFormATCs.on("click", function (e) {
    console.log('[Klaviyo] Add To Cart Triggered: ', _learnq);
    addedToCart();
  });


  $('.productSubTickBox').click(function(){
      $(this).toggleClass('active');
      var sellingPlan = $(this).attr('data-sub-id');
      if ($(this).hasClass('active')){
          
          $('input[name="selling_plan"]').attr('value', sellingPlan);
          $('[data-selling-plan-group-option-radio]').trigger('click');
          $('.product_prices-container[data="sub"]').removeClass('hided');
          $('.product_prices-container[data="otp"]').addClass('hided');
      }
      else{
         
         $('input[name="selling_plan"]').attr('value', '');
         $('[data-one-time-option-radio]').trigger('click');
         $('.product_prices-container[data="otp"]').removeClass('hided');
         $('.product_prices-container[data="sub"]').addClass('hided');
      }
  });

  function setDefaultValue(){
      var sellingPlan = $('.productSubTickBox').attr('data-sub-id');
      if ($('.productSubTickBox').hasClass('active')){
          
          $('input[name="selling_plan"]').attr('value', sellingPlan);
          $('[data-selling-plan-group-option-radio]').trigger('click');
          
      }
      else{
         
         $('input[name="selling_plan"]').attr('value', '');
         $('[data-one-time-option-radio]').trigger('click');
         
      }
  }

  setTimeout(function(){
    setDefaultValue();
  },1000);


  $('.product-selector__wrapper').change(function(){
    setTimeout(function(){
      setDefaultValue();
    },500);

    setTimeout(function(){
      var currentId = $('.product__form').find('input[name="id"]').attr('value');
      $('.product_price-regular').addClass('hided');
      $('.product_price-regular[data-id="'+currentId+'"]').removeClass('hided');
    },500);
   
    
  });


 setInterval(function () {
  const upCart = document.querySelector('#upCart');
  if (upCart && upCart.shadowRoot) {
    const el = upCart.shadowRoot.querySelector('.SubscriptionUpgradesModule_dropdownWrapper__');
    if (el && el.style.display !== 'none') {
      el.style.display = 'none';
    }
  }
}, 100);
  
  
});